import { FC } from 'react';

import { ICON_STROKE_WIDTH } from 'views/components/UI/Icons/icons.constants';
import { IIconProps } from 'views/components/UI/Icons/icons.interface';

const PriorityTrivial: FC<IIconProps> = ({
  size = '16',
  color = 'var(--sk-icon-subtle)',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 2.48169L6.98985 6.47154C7.54774 7.02943 8.45226 7.02943 9.01015 6.47154L13 2.48169M3 8.19597L6.98985 12.1858C7.54774 12.7437 8.45226 12.7437 9.01015 12.1858L13 8.19597"
      stroke={color}
      strokeWidth={ICON_STROKE_WIDTH}
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export { PriorityTrivial };
